import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from "../contexts/auth";
import { getCashesTotalURL } from '../utils/api';

const useGetCashTotal = ({ 
        setErrors
    }) => {
        
    const { auth } = useAuth();
    const [ gettingCashesTotal, setGettingCashesTotal ] = useState(false);
    const [ totalCashes, setTotalCashes ] = useState([]);
    const [ gettingCashesTotalReqSuccess, setGettingCashesTotalReqSuccess ] = useState(false);
    
    useEffect(() => {

        if (gettingCashesTotal) {
            axios.get(getCashesTotalURL, 
            {
                headers: {
                    Authorization: `Bearer ${auth.authToken}`
                }
            }).then(result => {
                setGettingCashesTotal(false);
                if (result.status === 200) {
                    const data = result.data.data;
                    setGettingCashesTotalReqSuccess(true);
                    setTotalCashes(data);         
                } else {
                    // console.log(result.data.errors);
                    if (setErrors) {
                        setErrors(result.data.errors);
                    }
                    setGettingCashesTotalReqSuccess(false);
                    // setOperatorAddErrors(result.data.errors);
                }
            }).catch(e => {
                if (e.response === undefined) {
                    // console.log(e);
                    if (setErrors) {
                        setErrors(['Could not connect to server']);
                    }
                    // setOperatorAddErrors(['Could not connect to server!'])
                } else {
                    // console.log(e.response.data.errors);
                    // setOperatorAddErrors(e.response.data.errors)
                    if (setErrors) {
                        setErrors([e.response.data.errors]);
                    }
                }
                setGettingCashesTotalReqSuccess(false);
                setGettingCashesTotal(false);
            });
        }
    }, [gettingCashesTotal]);

    return { totalCashes, gettingCashesTotal, setGettingCashesTotal, gettingCashesTotalReqSuccess };
}

export default useGetCashTotal;